import { Trans, useTranslation } from "react-i18next";
import { Checkbox, Text } from "@ucl/react-library";
import { useFormContext } from "react-hook-form";

import { translationMapping } from "src/utils/translation-mappings";
import { useBoundInput } from "src/hooks/use-bound-input";

interface ImportantInformationProps {
  showOptInInfo: boolean;
  docChallenge?: boolean;
}

export const ImportantInformation = ({ showOptInInfo, docChallenge = false }: ImportantInformationProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "importantInformation",
  });
  const { t: genericT } = useTranslation();

  const { control } = useFormContext();
  const agreeCheckboxProps = useBoundInput({
    name: "agreeTsAndCs",
    control,
  });

  return (
    <div className="flex flex-col gap-5" data-testid="aboutScheme">
      <div className="flex flex-col gap-3">
        <Text.P size="large" fontWeight="semi-bold">
          {t("aboutScheme")}
        </Text.P>

        {showOptInInfo && <Text.P size="large">{t("para1")}</Text.P>}
        {docChallenge && (<Text.P size="large">{t("docChallengeInfo")}</Text.P>)}

        <Text.P size="large">{t("para2")}</Text.P>

        <Text.P size="large">
          <Trans i18nKey="importantInformation.para3" components={translationMapping(genericT)} />
        </Text.P>

        <Text.P size="large">{t("para4")}</Text.P>
      </div>

      <Checkbox
        {...agreeCheckboxProps}
        label={t("agreeCheckbox")}
        checkboxValue={Number.parseInt(String(agreeCheckboxProps.value))}
        onChange={(_, value) => {
          agreeCheckboxProps.onChange(value);
        }}
        data-testid="agreeCheckbox"
        size={"large"}
      />
    </div>
  );
};
